import { Box, Tabs, Tab, Divider } from "@mui/material";
import { CustomCard } from "components/ui/customComponents/customCard";
import { BannerInfoUser } from "components/settings/profile/bannerInfoUser";
import { SectionMyAccount } from "components/settings/profile/sectionMyAccount";
import { useEffect } from "react";

export const ProfileScreen = () => {
  useEffect(() => {
    document.title = "Mi Perfil - Tribunal Electrónico ";
  }, []);

  return (
    <Box className="w-full p-0 lg:px-10 xl:px-10">
      <CustomCard>
        <Box
          sx={{
            width: "100%",
            paddingX: "0px",
            paddingY: "0px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Tabs value={0} onChange={() => console.log()} centered>
            <Tab label="Perfil Usuario" />
          </Tabs>
        </Box>
        <Divider />
        <Box
          component="div"
          sx={{
            maxWidth: {
              xs: "100%",
              sm: "100%",
              md: "100%",
              lg: "70%",
              xl: "70%",
            },
            marginX: "auto",
            marginY: "3rem",
          }}
        >
          <BannerInfoUser />
          <SectionMyAccount />
        </Box>
      </CustomCard>
    </Box>
  );
};
